import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect, useState } from 'react';
import './index.css'
export default function Leyenda() {
    const [nivelTrafico, setNivelTrafico] = useState(3)

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setNivelTrafico(config.NIVEL_TRAFICO)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <h3 style={{ marginTop: '0', display: 'flex', alignItems: 'center' }}>Leyenda <div style={{ width: '30px', height: '30px', marginLeft: '40px' }}><KeyboardArrowUpIcon /></div></h3>
            <div style={{ height: '500px', overflowY: 'auto', overflowX: 'hidden' }}>

                <p className='item' style={{ marginRight: '-1px' }}>Aparcamientos</p>
                <p className='subitem'><img className='imagen-camara-cluster' src='parking-cluster.png' alt="imagen" /> Clúster Libres</p>
                <p className='subitem' style={{ marginTop: '-7px' }}><img className='imagen-camara-cluster' src='parking-cluster-red.png' alt="imagen" /> Clúster Llenos</p>
                <p className='subitem' style={{ marginTop: '-3px' }}><img className='imagen-parking' src='azul.png' alt="imagen" />Libre</p>
                <p className='subitem' style={{ marginTop: '3px' }}><img  className='imagen-parking' src='amarillo.png' alt="imagen" />Casi Lleno</p>
                <p className='subitem' style={{ marginTop: '3px' }}><img  className='imagen-parking' src='rojo.png' alt="imagen" />Lleno</p>

                <p className='item'>Cámaras de tráfico</p>
                <p className='subitem'><img className='imagen-camara-cluster' src='camara-cluster.png' alt="imagen" />Clúster Cámara</p>
                <p className='subitem'><img className='imagen-camara-cluster' src='FCAM_L.png' alt="imagen" /> Cámara</p>

                <p className='item'>Pilonas</p>
                <p className='subitem'><img className='imagen-pilona-señal' src='cluster-pilona.png' alt="imagen" />Clúster Pilona</p>
                <p className='subitem'><img className='imagen-pilona-señal' src='abierto.png' alt="imagen" />Abierta</p>
                <p className='subitem'> <img className='imagen-pilona-señal' src='cerrado.png' alt="imagen" />Cerrada</p>
                <p className='subitem'><img className='imagen-pilona-señal' src='carga_descarga.png' alt="imagen" />Carga/Descarga</p>
                <p className='subitem'><img className='imagen-pilona-señal' src='normal.png' alt="imagen" />Normal</p>
                <p className='subitem'><img className='imagen-pilona-señal' src='no_comunica.png' alt="imagen" />Mantenimiento</p>

                <p  className='item'>Incidencias</p>
                <p className='subitem incidencia' ><img className='imagen-incidencia' src='incidencia1.png' alt="imagen" />Accidente</p>
                <p className='subitem incidencia' > <img className='imagen-incidencia' src='incidencia2.png' alt="imagen" />Obras</p>
                <p className='subitem incidencia' ><img className='imagen-incidencia' src='incidencia3.png' alt="imagen" />Peligro</p>

                <p className='item'>Paneles</p>
                <p className='subitem'><img style={{ width: '40px', marginRight: '10px' }} src='panel.png' alt="imagen" />Mensaje Variable</p>

                <p className='item'>Señales</p>
                <p className='subitem'><img className='imagen-pilona-señal' src='senal.png' alt="imagen" />Panel Informativo</p>

                <p className='item'>Tráfico</p>
                {nivelTrafico === 3 &&
                    <>
                        <p className='subitem'><span className='tramo green' /> Fluido</p>
                        <p className='subitem'><span className='tramo yellow' /> Intenso</p>
                        <p className='subitem'><span className='tramo red' /> Retenciones</p>
                        <p className='subitem'><span className='tramo purple'  /> Sin Datos</p>
                    </>
                }
                {nivelTrafico === 5 &&
                    <>
                        <p className='subitem'><span className='tramo blue' />Muy Fluido</p>
                        <p className='subitem'><span className='tramo green' /> Fluido</p>
                        <p className='subitem'><span className='tramo yellow' /> Denso</p>
                        <p className='subitem'><span className='tramo pink' /> Muy Denso</p>
                        <p className='subitem'><span className='tramo red' /> Congestión</p>
                        <p className='subitem'><span className='tramo purple' /> Sin Datos</p>
                    </>
                }
            </div>
        </div>
    );
}